import MainLayout from "../../layouts/MainLayout";
import mainStyle from "../../style/Main.module.css";
import {
  TbInfoCircle,
  TbUserCode,
  TbBook,
  TbLicense,
  TbCalendarTime,
} from "react-icons/tb";
import style from "../../style/Pages/AboutUs.module.css";
const AboutUs = () => {
  //   const [isDarkMode, setIsDarkMode] = useState(false);

  return (
    <MainLayout>
      <div className={mainStyle.mainPageHeader}>
        <div>
          <p>Account Summary</p>
        </div>
      </div>
      <div className={mainStyle.mainContentView} style={{ height: "92%" }}>
        <div className={mainStyle.mainContentViewsb}>
          <div className={style.aboutWrapper}>
            <div className={style.topBar}>
              {/* <Link to="/help" className={style.backLink}>
                <TbArrowLeft className={style.backIcon} /> Back to Help Center
              </Link> */}
              <div className={style.header}>
                <TbInfoCircle className={style.headerIcon} />
                <h1>About </h1>
              </div>
            </div>

            <div className={style.cardGrid}>
              <div className={style.card}>
                <TbCalendarTime className={style.cardIcon} />
                <h2>Version</h2>
                <p>
                  <strong>1.0.0</strong> – Released July 2025
                  <br />
                  Last update: 15 July 2025
                </p>
              </div>

              <div className={style.card}>
                <TbUserCode className={style.cardIcon} />
                <h2>Developed By</h2>
                <p>
                  Sea Sense Software Solutions
                  <br />
                  Lead: XYZ
                  <br />
                  Contributors: Dev & UI/UX Teams
                </p>
              </div>

              <div className={style.card}>
                <TbBook className={style.cardIcon} />
                <h2>Resources</h2>
                <ul>
                  <li>
                    <a
                      href="/docs/user"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      User Documentation
                    </a>
                  </li>
                  <li>
                    <a
                      href="/docs/api"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      API Reference
                    </a>
                  </li>
                  <li>
                    <a
                      href="/support"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Support
                    </a>
                  </li>
                </ul>
              </div>

              <div className={style.card}>
                <TbLicense className={style.cardIcon} />
                <h2>License</h2>
                <p>
                  This application is licensed under the{" "}
                  <strong>MIT License</strong>. All third-party assets are used
                  under open-source licenses.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AboutUs;
